<template>
  <div class="cp-your-apps main" :key="z">
    <div class="divider" />

    <div class="row" @click="goto('commerce_page/customer-app')">
      <p>
        <i class="fa fa-users icon" />Customer App
        <!-- <span class="is-pulled-right link has-text-primary">Set-up</span> -->
      </p>
      <div v-if="customerAppIcon" class="value">
        <i class="fa fa-check-circle has-text-success" />&nbsp;Provisioned
        <img :src="customerAppIcon" />
      </div>
      <div v-else class="value">
        <i class="far fa-edit has-text-info" />&nbsp;Set Icon
      </div>
    </div>

    <div class="divider" />

    <div class="row" @click="goto('commerce_page/shop-manager-app')">
      <p>
        <i class="fa fa-store-alt icon" />Shop Manager App
        <!-- <span class="is-pulled-right link has-text-primary">Set-up</span> -->
      </p>
      <div v-if="shopManagerAppIcon" class="value">
        <i class="fa fa-check-circle has-text-success" />&nbsp;Provisioned
        <img :src="shopManagerAppIcon" />
      </div>
      <div v-else class="value">
        <i class="far fa-edit has-text-info" />&nbsp;Set Icon
      </div>
    </div>

    <div class="divider" />

    <div class="row" @click="goto('commerce_page/commerce-agent-app')">
      <p>
        <i class="fa fa-male icon" />Commerce Agent App
        <!-- <span class="is-pulled-right link has-text-primary">Set-up</span> -->
      </p>
      <div v-if="commerceAgentAppIcon" class="value">
        <i class="fa fa-check-circle has-text-success" />&nbsp;Provisioned
        <img :src="commerceAgentAppIcon" />
      </div>
      <div v-else class="value">
        <i class="far fa-edit has-text-info" />&nbsp;Set Icon
      </div>
    </div>

    <div class="divider" />

    <div class="row" @click="goto('commerce_page/delivery-driver-app')">
      <p>
        <i class="fa fa-motorcycle icon" />Delivery Driver App
        <!-- <span class="is-pulled-right link has-text-primary">Set-up</span> -->
      </p>
      <div v-if="deliveryDriverAppIcon" class="value">
        <i class="fa fa-check-circle has-text-success" />&nbsp;Provisioned
        <img :src="deliveryDriverAppIcon" />
      </div>
      <div v-else class="value">
        <i class="far fa-edit has-text-info" />&nbsp;Set Icon
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CPYourApps",
  components: {},
  props: {
    b: Object,
  },
  data() {
    return {
      z: 0,
    };
  },
  computed: {
    business() {
      return this.b;
      // return this.$store.state.selectedBusiness;
    },
    customerAppIcon() {
      if (!this.business.data.customer_app) return null;
      return this.business.data.customer_app.icon_192;
    },
    shopManagerAppIcon() {
      if (!this.business.data.shop_manager_app) return null;
      return this.business.data.shop_manager_app.icon_192;
    },
    commerceAgentAppIcon() {
      if (!this.business.data.commerce_agent_app) return null;
      return this.business.data.commerce_agent_app.icon_192;
    },
    deliveryDriverAppIcon() {
      if (!this.business.data.delivery_driver_app) return null;
      return this.business.data.delivery_driver_app.icon_192;
    },
  },
  mounted() {
    this.$store
      .dispatch("getAndSelectBusiness", this.business.id)
      .then(() => (this.z += 1))
      .catch((err) => this.apiError(err));
  },
  methods: {
    // toggleOrderSummary() {
    //   this.showOrderSummary = !this.showOrderSummary;
    // },
  },
};
</script>

<style scoped>
.main {
  /* background-color: white; */
  /* padding: 8px 0; */
  height: 100%;
}
.order-summary {
  margin: 0 8px;
  margin-top: -4px;
  /* font-weight: 500; */
  /* color: grey; */
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.heading {
  font-weight: 500;
  color: grey;
  margin-bottom: 0;
  margin-top: 5px;
}
.more {
  position: absolute;
  right: 0;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.value {
  color: grey;
  margin-left: 32px;
  border-bottom: 1px dotted rgb(230, 230, 230);
}
img {
  position: absolute;
  right: 6px;
  margin-top: -28px;
  height: 56px;
  width: 56px;
  border-radius: 20%;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
  background-color: #ccc;
}
</style>